const studentSearch = "_275sfro2zf";

export { studentSearch };
import "./molecule.tablist.style.linaria.module.css";
//# sourceMappingURL=molecule.tablist.style.js.map
